module.exports = __webpack_public_path__ + "static/media/date.f17da260.svg";